<template>
  <client-only>
    <div class="full-page-wrapper login-page">
      <OtherPageHeader activeSection="login"></OtherPageHeader>
      <feed-preview v-show="show" style="z-index: 0;"></feed-preview>
      <div class="flex h-screen feed-overlay flex-col justify-center items-center red-gradient-bg">
        <login></login>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import Login from '~/components/login/Login.vue';
import FeedPreview from "~/components/FeedPreview.vue";
import { onMounted, ref } from "vue";
import OtherPageHeader from "~/components/layout/OtherPageHeader.vue";
const show = ref(false);

onMounted(async () => {
  if (process.client) {
    setTimeout(async () => {
      show.value = true;
    }, 500)
  }
})
</script>

<style scoped>
@media (max-width: 768px) {
  .login-page .feed-overlay {
    padding: 0 16px;
    align-items: stretch;
    justify-content: center;
  }
}
</style>
